<template>
  <div class="pt-12 px-3 text-gray-600 md:pt-10 text-center mx-auto max-w-450">
    <h1 class="ota-h1 mb-5" v-text="$t('CustomerService.ContactBlock.Title')" />
    <p class="ota-p16 mb-10" v-text="$t('CustomerService.ContactBlock.ChatDescription')" />
    <div class="text-center">
      <OButton tag="a" :to="chatbotLink" variant="secondary">
        <span v-text="$t('CustomerService.ContactBlock.Chat')" />
      </OButton>
    </div>
  </div>
</template>

<script>
import OButton from '@/components/OButton'

export default {
  name: 'ContactBlock',
  components: {
    OButton
  },
  props: {
    locale: {
      type: String,
      default: ''
    }
  },
  computed: {
    chatbotLink () {
      return `${process.env.CHATBOT_BASE_URL}/${this.locale}`
    }
  }
}
</script>

<style lang="postcss" scoped>
.new-gray-bg {
  background-color: #F5F5F5;
}

.green {
  background-color: #00A351;
}

.red {
  background-color: #E6464C;
}

.small-container {
  max-width: 92rem;
}

.arrow-right {
  @apply fill-gray-600 cursor-pointer text-center h-4 w-4 inline;
}

.max-width {
  max-width: 43rem;
}

@screen md {
  .max-w-450 {
    max-width: 45rem;
  }
}
</style>
